import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import './LoginPage.css';
import { Link } from 'react-router-dom';

function LoginPage({ setLoggedIn }) {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [message,  setMessage]  = useState('');
  const auth = getAuth();

  const loginUser = (e) => {
    e.preventDefault();
    if (!email || !password) { setError('Please enter your email and password.'); return; }
    signInWithEmailAndPassword(auth, email, password)
      .then(() => setLoggedIn(true))
      .catch(() => setError('Incorrect email or password.'));
  };

  const resetPassword = () => {
    if (!email) { setError('Enter your email above to reset your password.'); return; }
    sendPasswordResetEmail(auth, email)
      .then(() => { setMessage('Password reset email sent. Check your inbox.'); setError(''); })
      .catch(() => setError('Error sending reset email. Please try again.'));
  };

  return (
    <div className="login-container">
      <div className="login-logo">
        <img src={process.env.PUBLIC_URL + '/mascot-logo.png'} alt="FalconRide" className="login-logo-img" />
        <h1>Falcon<span>Ride</span></h1>
        <p>USAFA Community Rideshare</p>
      </div>

      <form onSubmit={loginUser} className="login-form">
        {error   && <p className="error">{error}</p>}
        {message && <p className="success">{message}</p>}

        <input type="email"    placeholder="Email"    value={email}    onChange={e => setEmail(e.target.value)}    autoComplete="email" />
        <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" />

        <button type="submit">Log In</button>

        <p className="forgot-password-link" onClick={resetPassword}>Forgot Password?</p>

        <div className="login-divider">or</div>

        <Link to="/signup">Don't have an account? Sign Up</Link>
      </form>
    </div>
  );
}

export default LoginPage;
